import { GroupsDetailedProvider } from './groupsDetailedContext'
import { GroupsIncome } from './groupsIncome'


export function GroupsDetailedInformations() {
   
    return(
    
        <GroupsDetailedProvider>

            <GroupsIncome />

        </GroupsDetailedProvider>
      
    )
}
